import { InjectionToken } from '@angular/core';
import { FilterContentItem } from './item';

export const FILTER_CONTENT_ITEM = new InjectionToken<FilterContentItem>('FilterContentItem');
